<template>
  <PageContainer>
    <div class="page-content no-button">
      <div class="title animated">
        <p>{{this.question.question_text}}</p>
      </div>

      <ButtonValue v-for="(option, index) in questionOptions" :key="index"
        :isActive="selection === option.answer_text" :onClick="updateSelection" v-bind:value="option.answer_text"
        :class="skipOptionValues.includes(option.answer_text) ? 'isSkipOption' : ''"
        :extraClass="'value-option-spaced'">
        <span v-html="formatAnswerText(option.answer_text || '', '!', undefined, 'p-smaller p-spaced-before')"></span>
      </ButtonValue>
    </div>

    <div class="footer-container">
      <ProgressBar />
    </div>
  </PageContainer>
</template>

<script>
import PageContainer from '../../shared/components/PageContainer';
import ButtonValue from '../../shared/components/ButtonValue';
import ProgressBar from '../../shared/components/ProgressBar';
import { delayedTransition, ROUTE_NAMES } from '../router';
import Trackeable from '../../Trackeable';
import ProgressFull from '../mixins/ProgressFull';
import { formatTextFirstBold } from '../../shared/utils';
import { DELAY_TRANSITION_MS_QUESTIONS } from '../contants';

export default {
  name: 'attract',
  components: {
    PageContainer,
    ButtonValue,
    ProgressBar
  },
  mixins: [Trackeable, ProgressFull],
  data() {
    const question = this.$store.getters.getQuestion('attract');
    const questionOptions = this.$store.getters.getOptions('attract');
    const skipOptionValues = questionOptions.map(o => { if (o.isSkipOption) { return o.answer_text } }).filter(o => o) || [];
    return {
      selection: null,
      question,
      questionOptions,
      skipOptionValues
    }
  },
  methods: {
    updateSelection(event) {
      this.selection = event.currentTarget.value;
      this.$store.commit('updateAnswers', { attract: this.selection });
      const path = this.skipOptionValues.includes(this.selection) ? ROUTE_NAMES.WeightLossProgramTried3 : ROUTE_NAMES.MotivationScience;
      delayedTransition(this.$router, path, DELAY_TRANSITION_MS_QUESTIONS);
    },
    formatAnswerText: formatTextFirstBold
  }
}
</script>
